//import {FemaGoTable } from 'app-ui-componentlibrary';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import SearchResultsForCommitment from './SearchResultsForCommitment';
import FundingOpportunityContext from './FundingOpportunityContext';
import _ from 'lodash';
import React, {useState, useContext} from 'react';
import {Segment, Button} from 'semantic-ui-react';
import REST from 'go/requests/rest';
import {
  showDollarAmountWithDollar,
  formatDateMMDDYYYY,
  formatLineNumber,
} from 'common/utils';

const SearchForCommitment = ({handleCommitmentSelect, existingCommitmentIds}) => {
  const [results, setResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const fundingOpportunity = useContext(FundingOpportunityContext);
  const searchTermCharacterLimit = 20;

  const foName = _.get(
    fundingOpportunity,
    'fundingOpportunityName',
    'this funding opportunity'
  );

  const handleSearch = async () => {
    if (!searchTerm) {
      setErrorMessage('Please enter a commitment number.');
      return;
    }

    if (searchTerm.length > searchTermCharacterLimit) {
      setErrorMessage(
        `Your response must be less than or equal to ${searchTermCharacterLimit} characters. Please enter a valid commitment number.`
      );
      return;
    }

    if (_.includes(existingCommitmentIds, searchTerm)) {
      setErrorMessage(
        `Commitment number is already linked to ${foName}. Please enter a different commitment number.`
      );
    } else {
      REST.commitment
        .getCommitment(searchTerm)
        .then(REST.handler.handleResponse)
        .then((data) => {
          // filter out all but those objects having line # 1
          let commitmentDetails = _.filter(
            _.get(data, 'commitmentDetailsResponse', []),
            (detailObj) => _.get(detailObj, 'commitmentLineNumber', 0) == 1
          );
          commitmentDetails = _.map(commitmentDetails, (elem) => {
            // get and set formatted versions of props for display
            let commitmentIdAndSeq = `${_.get(
              elem,
              'commitmentNumberId',
              '???'
            )} - ${formatLineNumber(_.get(elem, 'commitmentLineNumber', '0'))}`;
            let startDate = formatDateMMDDYYYY(
              new Date(_.get(elem, 'commitmentStartDate', null)).toISOString()
            );
            let endDate = formatDateMMDDYYYY(
              new Date(_.get(elem, 'commitmentEndDate', null)).toISOString()
            );
            let amount = showDollarAmountWithDollar(_.get(elem, 'commitmentAmount', 0));
            let availableAmount = showDollarAmountWithDollar(
              _.get(elem, 'commitmentAvailableAmount', 0)
            );
            let commitmentSeq = formatLineNumber(
              _.get(elem, 'commitmentLineNumber', '0')
            );
            return {
              ...elem,
              commitmentIdAndSeq,
              commitmentAmount: amount,
              commitmentAvailableAmount: availableAmount,
              commitmentStartDate: startDate,
              commitmentEndDate: endDate,
              commitmentLineNumber: commitmentSeq,
            };
          });
          setResults(commitmentDetails);
          if (commitmentDetails.length == 0) {
            setErrorMessage(
              'Commitment number not found. Please enter a valid commitment number.'
            );
          }
        })
        .catch((e) => {
          setResults([]);
          console.error(`Error searching for commitmentId: ${searchTerm}`, {e});
          return Promise.reject(e);
        });
    }
  };
  const handleChange = async (e, entry) => {
    if (!_.isEmpty(errorMessage)) {
      setErrorMessage(null);
    }
    setResults([]);
    handleCommitmentSelect(null);
    setSearchTerm(_.trim(entry.value));
  };

  return (
    <Segment>
      <div className="search-bar">
        <p>Enter commitment number or document number from SF-146</p>
        <div id="divForTextBoxFieldAndButton" className="addFOCSearch">
          <TextBoxField
            size="medium"
            label="Commitment number"
            title="Enter commitment number to find"
            name="commitmentId"
            id="addFocNewCommitmentId"
            handleChange={handleChange}
            value={searchTerm}
            errorMessages={[errorMessage]}
            displayError={!_.isEmpty(errorMessage)}
          />
          <div className="button">
            <Button primary compact onClick={handleSearch}>
              Search
            </Button>
          </div>
        </div>
      </div>

      {results && results.length > 0 && (
        <SearchResultsForCommitment
          results={results}
          handleCommitmentSelect={handleCommitmentSelect}
        />
      )}
    </Segment>
  );
};

export default SearchForCommitment;
